/**
 * TRIÁSICO — Visor de imágenes ligero y accesible para tr-gallery.
 * <dialog> nativo: Esc cierra, el foco vuelve al botón de origen, flechas ← → navegan.
 */
let dialog;

function buildDialog() {
  dialog = document.createElement('dialog');
  dialog.className = 'tr-lightbox';
  dialog.setAttribute('aria-label', 'Imagen ampliada');
  dialog.innerHTML = `
    <div class="tr-lightbox__stage">
      <img class="tr-lightbox__img" alt="" decoding="async">
      <p class="tr-lightbox__caption" aria-live="polite"></p>
    </div>
    <button type="button" class="tr-lightbox__btn tr-lightbox__prev" aria-label="Imagen anterior">‹</button>
    <button type="button" class="tr-lightbox__btn tr-lightbox__next" aria-label="Imagen siguiente">›</button>
    <button type="button" class="tr-lightbox__btn tr-lightbox__close" aria-label="Cerrar">×</button>
  `;
  document.body.append(dialog);

  dialog.querySelector('.tr-lightbox__close').addEventListener('click', () => dialog.close());
  dialog.querySelector('.tr-lightbox__prev').addEventListener('click', () => dialog.trGallery?.step(-1));
  dialog.querySelector('.tr-lightbox__next').addEventListener('click', () => dialog.trGallery?.step(1));
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.classList.contains('tr-lightbox__stage')) dialog.close();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') dialog.trGallery?.step(-1);
    if (event.key === 'ArrowRight') dialog.trGallery?.step(1);
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.removeProperty('overflow');
    dialog.trGallery?.returnFocus();
  });
}

class TrGallery extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-lightbox')) return;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.tr-gallery__open');
      if (!button) return;
      this.open(this.buttons.indexOf(button));
    });
  }

  get buttons() {
    return [...this.querySelectorAll('.tr-gallery__open')];
  }

  open(index) {
    if (!dialog) buildDialog();
    this.index = index;
    this.opener = this.buttons[index];
    dialog.trGallery = this;
    const single = this.buttons.length < 2;
    dialog.querySelector('.tr-lightbox__prev').hidden = single;
    dialog.querySelector('.tr-lightbox__next').hidden = single;
    this.render();
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  }

  step(delta) {
    const total = this.buttons.length;
    this.index = (this.index + delta + total) % total;
    this.opener = this.buttons[this.index];
    this.render();
  }

  render() {
    const button = this.buttons[this.index];
    const img = dialog.querySelector('.tr-lightbox__img');
    img.src = button.dataset.full;
    img.alt = button.dataset.alt || '';
    dialog.querySelector('.tr-lightbox__caption').textContent = button.dataset.caption || '';
  }

  returnFocus() {
    this.opener?.focus();
  }
}

if (!customElements.get('tr-gallery')) customElements.define('tr-gallery', TrGallery);
